export default __webpack_public_path__ + "static/media/DSC_0528.f8a9da6d.jpg";